<h2 mat-dialog-title>{{dialogTitle | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <table mat-table
        [dataSource]="matTabDataSource"
        style="width: 100%;"
        class="cmat-add-border">

        <ng-container matColumnDef="LINE">
            <th mat-header-cell *matHeaderCellDef style="min-width: 50px;"> # </th>
            <td mat-cell *matCellDef="let row"> {{row.NoLineWeb}} </td>
        </ng-container>

        <ng-container matColumnDef="MESSAGE">
            <th mat-header-cell *matHeaderCellDef> {{'Message' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.Mess}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="matTabColumn"></tr>
        <tr mat-row *matRowDef="let row; columns: matTabColumn;" class="error-line"></tr>
    </table>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>{{'Fermer' | translate}}</button>
</mat-dialog-actions>
